import script from "./MoneyReceiptStatements.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyReceiptStatements.vue?vue&type=script&setup=true&lang=js"

import "./MoneyReceiptStatements.vue?vue&type=style&index=0&id=d45b3ade&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d45b3ade"]])

export default __exports__